import React from 'react';
import { Navigate } from 'react-router-dom';

const NonAuthLayout = (props) => {
  const adminInfo = localStorage.getItem("adminUser");

  if (adminInfo) {
    return <Navigate to="/dashboard" />;
  }
  
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}

export default NonAuthLayout